import axios from '@/utils/axios';
import { ip3 } from '@/utils/constants';

export async function getDiemDanhGiaoVien(payload: {
  page: number;
  limit: number;
  cond?: any;
  donViId?: string;
  ngay?: number; 
  thang?: number;
  nam?: number;
}) {
  const { page, limit, cond, donViId, ngay, thang, nam } = payload;
  let cond2:any
  const newCond = { ...cond };
  if(newCond["user.profile.fullname"]) {
    cond2= {
      regex: newCond["user.profile.fullname"]["$regex"],
      options: newCond["user.profile.fullname"]["$options"]
    }
    delete newCond['user.profile.fullname'];
  }
  return axios.get(`${ip3}/cham-cong/pageable/${donViId}`, {
    params: {
      page,
      limit,
      cond: {
        ...newCond,
        ngay,
        thang,
        nam,
        // trangThai: { $ne: 'Chưa chấm công' },
      },
      cond2: {
        ...cond2
      }
    },
  });
}

export async function xuLyDiemDanhGV(payload: any) {
  const { id } = payload;
  return axios.put(`${ip3}/cham-cong/${id}/trang-thai`, payload);
}
